import { useRef, useState } from "react";
import { Box, Typography, Button, Stack, Divider } from "@mui/material";

import Grid from "@mui/material/Grid2";
import { useQuery } from "@tanstack/react-query";
import { getAppHomeData } from "../../utilities/service";
import { useAuth } from "../../hooks/AuthContext";
import { useNavigate, useParams } from "react-router";
import BreadcrumbNavigation from "../../components/common/BreadcrumbNavigation";
import { CommonSection } from "../../components/common/CommonSection";
import { useLoading } from "../../hooks/LoadingContext";
import { styled } from "@mui/material/styles";
import DeliveryType from "./DeliveryType";
import ContactInfo from "./ContactInfo";
import { Outlet } from "react-router";
import { CCard } from "../../components/common/CCard";

export default function PreCheckout() {
  let { slug, sortKind, flavour } = useParams();
  const { setIsLoading, setProgress } = useLoading();
  let navigate = useNavigate();
  const dialogRef = useRef(null);

  const { user } = useAuth();
  const [favorites, setFavorites] = useState({});
  const [filterValues, setFilterValues] = useState({
    weight: null,
    sortType: sortKind || "priceLtoH",
    flavour: flavour || null,
  });

  //   const { isLoading, error, data } = useQuery({
  //     queryKey: ["customerCart"],
  //     queryFn: () => customerCart(user),
  //     onSettled: () => {
  //       setIsLoading(false);
  //       setProgress(100);
  //     },
  //   });
  //   useApiLoader(isLoading);

  const { isLoading, error, data } = useQuery({
    queryKey: ["getAppHomeData"],
    queryFn: getAppHomeData,
  });
  // console.log(isLoading, error, data);
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading checkout details</div>;

  const handleAddonDialog = () => dialogRef.current?.openDialog();
  const offers = data?.data?.sections?.[1];

  const heading = "Delivery address";
  if (error) return <div>Error loading checkout details</div>;
  return (
    <>
      <CommonSection
        style={{
          paddingTop: "32x !important",
          background: "var(--neutral-100)",
        }}
      >
        <BreadcrumbNavigation
          items={[
            { label: "Cart", path: "/cart" },
            { label: "Delivery details" },
          ]}
        />

        <Grid container spacing={3}>
          <Grid
            size={3}
            rowSpacing={2}
            sx={{ display: "flex", flexDirection: "column", rowGap: 5 }}
          >
            <DeliveryType />
            <ContactInfo />
          </Grid>
          <Grid size={9}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "24px",
                color: "var(--neutral-black)",
                textAlign: "left",
                lineHeight: "133%",
                mb: 2,
              }}
            >
              {heading}
            </Typography>
            <CCard sx={{ p: 3 }}>
              <Outlet />
            </CCard>
          </Grid>
        </Grid>
      </CommonSection>
    </>
  );
}

export const CartCard = styled(Box)(({ theme }) => ({
  border: "1px solid var(--neutral-300)",
  borderRadius: "8px",
  padding: "24px",
  background: "white",
}));
const BillLabel = styled(Box)(({ theme }) => ({
  fontWeight: 400,
  fontSize: "16px",
  color: "var(--neutral-800)",
  textAlign: "left",
  lineHeight: "150%",
}));
const BillValue = styled(Box)(({ theme }) => ({
  fontWeight: 700,
  fontSize: "16px",
  color: "var(--neutral-black)",
  textAlign: "right",
  lineHeight: "150%",
}));
